import React, { Component } from 'react';

class CompanyReg extends Component {
    state = {  }
    render() { 
        return ( 
            <div className="full-div">
                <div>CompanyReg</div>
            </div>
         );
    }
}
 
export default CompanyReg;